import { Layout, Menu } from "antd";
import classNames from "classnames";

import { useAppLayoutSidebar } from "./app-layout-sidebar.hook";

import "./app-layout-sidebar.style.less";

const { Sider } = Layout;

export const AppLayoutSidebar = () => {
  const {
    menuItems,
    selectedKeys,
    collapsed,
    collapsedWidth,
    setCollapsed,
    isXs,
  } = useAppLayoutSidebar();

  return (
    <Sider
      theme="light"
      breakpoint="xl"
      className={classNames("stelar-layout-sidebar", { "-xs": isXs })}
      collapsible
      collapsed={collapsed}
      collapsedWidth={collapsedWidth}
      onCollapse={() => setCollapsed(!collapsed)}
      trigger={isXs ? null : undefined} // hide default trigger on mobile -> the custom trigger is displayed in header
    >
      <Menu
        mode="inline"
        items={menuItems}
        selectable={false}
        selectedKeys={selectedKeys}
      />
    </Sider>
  );
};
